import { motion } from "framer-motion";
import { Compass, Hammer, Rocket, TrendingUp } from "lucide-react";

const steps = [
  { n: "01", title: "Discovery", desc: "We dig into your users, metrics and tech. You get a clear roadmap + fixed scope.", icon: Compass, bg: "bg-[#FCE7F3]" },
  { n: "02", title: "Build", desc: "Weekly demos. Typed code. Real tests. No 'it works on my machine' moments.", icon: Hammer, bg: "bg-[#E0F2FE]" },
  { n: "03", title: "Deploy", desc: "One-click CI/CD, monitoring, zero-downtime releases. Your team gets the keys.", icon: Rocket, bg: "bg-[#FBD46D]" },
  { n: "04", title: "Scale", desc: "Performance tuning, AI feature rollouts, infra optimization as you grow.", icon: TrendingUp, bg: "bg-[#6BCB77]" },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-32 border-b-4 border-gray-900 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-14">
          <div>
            <span className="inline-block bg-[#4D96FF] text-white border-[3px] border-gray-900 rounded-full px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] nb-shadow-sm">
              The Process
            </span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl leading-tight">
              Four steps. Zero drama.
            </h2>
          </div>
          <div className="relative max-w-md ml-auto">
            <img
              data-testid="process-image"
              src="https://static.prod-images.emergentagent.com/jobs/a8216672-e1e1-44b7-a0bd-e8478222755e/images/b71785d6c3f5703d1bd882c2f7e53ba4de53515ab97585f27734ab7aa49f1899.png"
              alt="Rocket blasting off from a laptop"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.45, delay: i * 0.1 }}
                data-testid={`process-step-${s.n}`}
                className={`${s.bg} border-[4px] border-gray-900 rounded-2xl p-7 nb-shadow nb-hover`}
              >
                <div className="flex items-center justify-between mb-5">
                  <span className="font-display text-5xl text-gray-900/20">{s.n}</span>
                  <div className="w-12 h-12 rounded-lg bg-white border-[3px] border-gray-900 flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                </div>
                <h3 className="font-display text-2xl md:text-3xl leading-tight mb-2">{s.title}</h3>
                <p className="text-base font-medium text-gray-800 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
